'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useHits } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useSearchUrlQueryParams from 'components/consumer/consumer-search/advanced-search/hooks/useSearchUrlQueryParams';
import { getBlogPath } from 'components/consumer/consumer-search/commons/helpers';
const ResultsHeader = t0 => {
  const $ = _c(6);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant !== "mobile";
  const t3 = variant === "mobile";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("mx-0 my-2.5 text-base font-bold", {
      "text-gray": t2,
      "text-brand block mt-[15px] mb-[7px]": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};

/**
 * StaticPageHits component - Next version (v7)
 * Uses useHits hook instead of legacy connectHits
 */
const StaticPageHitsNext = t0 => {
  const $ = _c(20);
  const {
    toggleSearchOpen,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    items: hits
  } = useHits();
  const {
    queryUrlParam: query
  } = useSearchUrlQueryParams();
  const currentPage = useUserCurrentPageType();
  let t2;
  if ($[0] !== hits) {
    t2 = hits.map(_temp);
    $[0] = hits;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  if (!items.length) {
    return null;
  }
  let t3;
  if ($[2] !== currentPage || $[3] !== query || $[4] !== toggleSearchOpen) {
    t3 = async () => {
      await toggleSearchOpen?.();
      avo.productsSearched({
        query,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
    };
    $[2] = currentPage;
    $[3] = query;
    $[4] = toggleSearchOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClick = t3;
  let t4;
  if ($[6] !== variant) {
    t4 = <ResultsHeader variant={variant}>Pages</ResultsHeader>;
    $[6] = variant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleClick || $[9] !== items || $[10] !== variant) {
    let t6;
    if ($[12] !== handleClick || $[13] !== variant) {
      t6 = item => <div key={item.objectID}><Link className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
          "block mr-2.5 text-[#585858]": variant === "desktop",
          "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": variant === "mobile"
        })} onClick={handleClick} to={item.finalURL}>{item.page}</Link></div>;
      $[12] = handleClick;
      $[13] = variant;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = items.map(t6);
    $[8] = handleClick;
    $[9] = items;
    $[10] = variant;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <div>{t5}</div>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div className="[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 static-pages">{t4}{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default StaticPageHitsNext;
function _temp(hit) {
  const isStoriesURL = (hit?.url || "").startsWith("/stories");
  const finalURL = (isStoriesURL ? getBlogPath(hit.url) : hit.url) || "";
  return {
    objectID: hit.objectID,
    page: hit.page,
    finalURL
  };
}